__turbopack_context__.v({
  "appleIcon": "PaymentMethodsScreen-module-scss-module__Cq-n4q__appleIcon",
  "buttons": "PaymentMethodsScreen-module-scss-module__Cq-n4q__buttons",
  "connector": "PaymentMethodsScreen-module-scss-module__Cq-n4q__connector",
  "fakeColorButton": "PaymentMethodsScreen-module-scss-module__Cq-n4q__fakeColorButton",
  "firstStepTitle": "PaymentMethodsScreen-module-scss-module__Cq-n4q__firstStepTitle",
  "stepper": "PaymentMethodsScreen-module-scss-module__Cq-n4q__stepper",
  "stepperIconFirst": "PaymentMethodsScreen-module-scss-module__Cq-n4q__stepperIconFirst",
  "stepperIconSecond": "PaymentMethodsScreen-module-scss-module__Cq-n4q__stepperIconSecond",
  "stepperIconThird": "PaymentMethodsScreen-module-scss-module__Cq-n4q__stepperIconThird",
  "termsCheckbox": "PaymentMethodsScreen-module-scss-module__Cq-n4q__termsCheckbox",
});
